import type { paths } from '../../types/authSchema';
import { getUserLocale } from '../../utils/getUserLocale';
import { authApiClient, resolveAuthApiErrorMessage } from './authApiClient';

type RequestVerificationCodeBody = NonNullable<
  NonNullable<
    paths['/api/v1/auth/request_verification_code']['post']['requestBody']
  >['content']['application/json']
>;

type RequestVerificationCodeSuccessResponse =
  paths['/api/v1/auth/request_verification_code']['post']['responses']['200']['content']['application/json'];

type RequestVerificationCodeFailureResponse = {
  success: false;
  email?: string;
  errorMessage: string;
};

export type RequestVerificationCodeResponse =
  | RequestVerificationCodeSuccessResponse
  | RequestVerificationCodeFailureResponse;

export async function requestVerificationCode(
  email: string,
  is_promotion_agreed: boolean
): Promise<RequestVerificationCodeResponse> {
  const locale = getUserLocale();
  const body: RequestVerificationCodeBody = {
    email,
    ...(locale ? { locale } : {}),
    is_promotion_agreed
  };

  try {
    const { data, error } = await authApiClient.POST('/api/v1/auth/request_verification_code', {
      body
    });

    if (data) {
      return data;
    }

    return {
      success: false,
      email,
      errorMessage: resolveAuthApiErrorMessage(
        error,
        'Failed to request verification code. Please try again.'
      )
    };
  } catch (error) {
    return {
      success: false,
      email,
      errorMessage: resolveAuthApiErrorMessage(
        error,
        'Failed to request verification code. Please try again.'
      )
    };
  }
}
